<div class="revision-date-tooltip__title">{{ 'GuidelineEditor.Header.RevisionDate.Label' | transloco }}</div>
<div class="revision-date-tooltip__description">
  {{
    'GuidelineEditor.Header.RevisionDate.Tooltip.DescriptionTop'
      | transloco: { soonToExpirePeriod: (soonToExpireUnitKey | transloco: { time: soonToExpireTime }) }
  }}
</div>
<div class="revision-date-tooltip__icons">
  <div class="revision-date-tooltip__icon">
    <mat-icon class="revision-date-tooltip__icon--warning" [icon]="'warning'" [iconSize]="15" />
    <div>{{ 'GuidelineEditor.Header.RevisionDate.Tooltip.ExpiresSoon' | transloco }}</div>
  </div>
  <div class="revision-date-tooltip__icon">
    <mat-icon class="revision-date-tooltip__icon--error" [icon]="'error'" [iconSize]="15" />
    <div>{{ 'GuidelineEditor.Header.RevisionDate.Tooltip.Expired' | transloco }}</div>
  </div>
</div>
<div class="revision-date-tooltip__description">{{ 'GuidelineEditor.Header.RevisionDate.Tooltip.DescriptionBottom' | transloco }}</div>
